import { ListChecks } from 'lucide-react'
import { memo } from 'react'

import { groupSelectionState } from '@/features/dashboard/components/watchlist-wizard/watchlist-wizard-grouping'
import { cn } from '@/lib/utils'
import { Instrument } from '@/types/generated/common/types'

interface WatchlistGroupSelectButtonProps {
  instruments: Instrument[]
  label: string
  size?: 'sm' | 'md'
  existingKeys: Set<string>
  selectedKeys: Set<string>
  selectAllLabel: string
  deselectAllLabel: string
  onToggle: (instruments: Instrument[]) => void
}

export const WatchlistGroupSelectButton = memo(function WatchlistGroupSelectButton({
  instruments,
  size = 'md',
  existingKeys,
  selectedKeys,
  selectAllLabel,
  deselectAllLabel,
  onToggle,
}: WatchlistGroupSelectButtonProps) {
  const selection = groupSelectionState(instruments, existingKeys, selectedKeys)

  return (
    <button
      type="button"
      disabled={selection.selectable.length === 0}
      onClick={(event) => {
        event.stopPropagation()
        onToggle(instruments)
      }}
      aria-pressed={selection.allSelected}
      aria-label={selection.allSelected ? deselectAllLabel : selectAllLabel}
      className={cn(
        'flex shrink-0 items-center justify-center rounded-sm border transition-colors disabled:cursor-not-allowed disabled:opacity-30',
        size === 'sm' ? 'size-5' : 'size-6',
        selection.allSelected
          ? 'border-emphasis bg-emphasis text-emphasis-foreground'
          : selection.noneSelected
            ? 'border-foreground/15 text-foreground/40 hover:border-foreground/30 hover:text-foreground/70'
            : 'border-foreground/30 bg-foreground/10 text-foreground/80'
      )}
    >
      <ListChecks className={size === 'sm' ? 'size-3' : 'size-3.5'} />
    </button>
  )
})
